import React from 'react';
import Popup from './Popup';

const Video = (({ history, title, videoId }) => {
  return (
    <Popup id="popup-video"
      onClose={() => history.goBack()}
      title="Vídeo"
      subtitle={title}>
      <section className="content">
        <div className="video-container">
          <iframe src={`https://www.youtube.com/embed/${videoId}?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=1`} frameBorder="0" allowFullScreen></iframe>
        </div>

        <div className="frame"></div>
      </section>
    </Popup>
  );
})
export default Video;



// WEBPACK FOOTER //
// ./src/components/Video.js